module.exports = __webpack_public_path__ + "static/media/16IT201.1a4ff550.jpg";